import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CommCard from "src/common/CommCard";
import CreateB2BInvoiceForm from "./CreateB2BInvoiceForm";

const CreateB2BInvoice = () => {
	const navigate = useNavigate();

	return (
		<CommCard
			showCardHeader
			headerTitle="Create B2B Invoice"
			helmetTitle="BTTF - Create B2B Invoice"
		>
			<Container maxWidth="md" sx={{ py: 3 }}>
				<CreateB2BInvoiceForm
					handleClose={() => navigate("/b2b/b2b-invoice")}
					onSuccess={() => navigate("/b2b/b2b-invoice")}
				/>
			</Container>
		</CommCard>
	);
};

export default CreateB2BInvoice;
